import React from "react";
import { useState } from "react";
import { Calendar } from "react-multi-date-picker";
import axiosInstance from "../../Config/axios";
import { API_URLS } from "../../Config/API_URLS";
import { useNavigate, useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useSnackbar } from "notistack";
import { useQueryClient } from "react-query";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const Quater = () => {
  const [value, setValue] = useState();
  const [product, setProduct] = useState(true);
  const [date, setDate] = useState();
  const currentDate = new Date();
  const futureDate = new Date(currentDate);
  futureDate.setMonth(currentDate.getMonth() + 3);
  const formattedfutureDate = futureDate.toISOString().split("T")[0];
  const formattedcurrentDate = currentDate.toISOString().split("T")[0];
  const { id, variant_id } = useParams();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();
  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }
  console.log(convert(value));

  const GetSubscriptionDaly = () => {
    const reqbody = new FormData();
    reqbody.append("subscription_plan_id", id);
    reqbody.append("product_variants_id", variant_id);
    reqbody.append("start_date", formattedcurrentDate);
    reqbody.append("select_quantity", 1);
    axiosInstance
      .post(API_URLS.quaterlySubscription, reqbody)
      .then((response) => {
        alert(response?.data?.message);
        response.data.response_code===200 && addToCart( variant_id)
        localStorage.getItem("token");
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleLogin = (event) => {
    event.stopPropagation();
  };
  const { enqueueSnackbar } = useSnackbar();

  const client = useQueryClient();
  const addToCart = ( variantId) => {
    const reqBody = new FormData();
    reqBody.append("product_id", variantId);
    reqBody.append("add_quantity", 1);
    axiosInstance
      .post(API_URLS.addToCart, reqBody)
      .then((response) => {
        client.refetchQueries(["myCartList"]);
        enqueueSnackbar(response.data.status);
        navigate("/subscription");
      })
      .catch((error) => {
        enqueueSnackbar("Something went wrong..!", { variant: "error" });
      });
  };

  return (
    <>
      <div className=" hm1 h-[500px] py-5 text-center text-white">
        <p className="text-4xl py-10">
          Quarterly Plan In 3 Months So Get Your Plan{" "}
        </p>
        <div className="flex gap-5 justify-center">
          <div className="flex flex-col gap-10">
            <p className="text-2xl">StartDate:</p>
            <p className="text-2xl">EndDate:</p>
          </div>
          <div className="flex flex-col gap-10">
            <p className="text-2xl">{formattedcurrentDate}</p>

            <p className="text-2xl">{formattedfutureDate}</p>

            <p className="text-2xl">{date?.price}</p>
          </div>
        </div>

        <div className="flex justify-center">
          <Button
            className="!p-3 hm2 !my-5 "
            onClick={GetSubscriptionDaly}
            variant="contained"
          >
            Confirm
          </Button>
        
        </div>
      </div>
    </>
  );
};

export default Quater;
